import React, { useEffect, useState } from "react";
import NameLogo from "../images/NameLogo.png";
import "../css/Profile.css";
import ApplyLeave from "./ApplyLeave";
import OfficeHoliday from "./OfficeHoliday";
import ApplyWFH from "./ApplyWFH";
import { selectUser } from "../stores/userSlice";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export const LeavePage = () => {
  const location = useLocation();
  const [currentActiveTab, setCurrentActiveTab] = useState(location.state?.activeTab || "1");
  const [leave, setLeave] = useState({});
  const user = useSelector(selectUser);
  
  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  const editLeaveReq = (data) => {
    setCurrentActiveTab("1");
    setLeave(data);
  };

  useEffect(() => {
    if(user?.role_type === "GT"){
      setCurrentActiveTab("3");
    }
  }, [user])
  
  const TabButton = ({ id, label }) => (
    <button
      type="button"
      onClick={() => toggle(id)}
      className={`relative px-5 py-3 text-sm font-medium whitespace-nowrap transition-all duration-200 border-b-2 ${
        currentActiveTab === id
          ? "border-blue-600 text-blue-600"
          : "border-transparent text-gray-500 hover:text-gray-700"
      }`}
    >
      {label}
    </button>
  );

  return (
    <div className="bg-transparent w-full h-full flex flex-col overflow-y-auto overflow-x-hidden">
      <div className="max-w-[1700px] mx-auto px-2 sm:px-4 py-2 sm:py-2 flex-1 w-full flex flex-col mb-2">
        <div className="sticky top-0 z-10 bg-[#f6f6f6] pb-3 pt-2 -mt-2 -mx-2 sm:-mx-4 px-2 sm:px-4">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="flex overflow-x-auto scrollbar-hide">
            {user?.role_type !== "GT" && (
              <>
                <TabButton id="1" label="Apply Leave" />
                <TabButton id="2" label="Apply WFH" />
              </>
            )}
            <TabButton id="3" label="Office Holiday" />
          </div>
        </div>
      </div>

        <div className="flex-1">
          {currentActiveTab === "1" && <ApplyLeave leave={leave} />}
          {currentActiveTab === "2" && <ApplyWFH />}
          {currentActiveTab === "3" && <OfficeHoliday />}
        </div>
      </div>

    </div>
  );
};
